

 
<template> 
    <CardRh :processando="processando" titulo="Atualizar" >   
        <div class="modal-body scroll-y m-5 div-body-card-form"> 
            <div class="row g-6 g-xl-12 mb-5">  
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                    <div class="mb-2" v-if="formulario.usuario">
                        <label for="instrutor" class="form-label">Instrutor</label>
                        <input type="text" v-model="formulario.usuario.nome" class="form-control form-control-solid" placeholder="Instrutor" disabled/>
                    </div> 
                </div> 
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-2">
                    <div class="mb-2">
                        <label for="pelotao" class="form-label">Pelotão</label>
                        <input type="text" v-model="formulario.pelotao" class="form-control form-control-solid" placeholder="Pelotão" disabled/>
                    </div> 
                </div> 
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                    <div class="mb-2" v-if="formulario.disciplina">
                        <label for="disciplina" class="form-label">Disciplina</label>
                        <input type="text" v-model="formulario.disciplina.descricao" class="form-control form-control-solid" placeholder="Disciplina" disabled/>
                    </div> 
                </div> 
            </div> 
            <div class="row g-6 g-xl-12"   >  
                <ListaCampoForm :campos="campos" :formulario="formulario"   ></ListaCampoForm>  
            </div>  
        </div>  
        <div class="modal-footer"  > 
            <BotaoSalvar  @click="salvar" :processando="processando" titulo="Atualizar"></BotaoSalvar>   
        </div> 
    </CardRh>  
</template>

<script lang="ts">
	import ModeloUpdatePagina from '@/views/paginas/sigap/modelos/ModeloUpdatePagina.vue';   
    import { Options   } from "vue-class-component"; 
    import {  Instrutor } from "./Instrutor"; 
    import   SiteUtils   from '@/assets/ts/aplicacao/site';
    import { PerfilConfig } from "@/core/config/PerfisConfig";
    import InstrutorService from   "@/service/v1/sigap/InstrutorService"  

    @Options({
        name: "InstrutorEdicao",
        components: {   },   
    }) 
    export default class InstrutorEdicao extends ModeloUpdatePagina {
           
        async created() {  
            this.campos =  Instrutor.campos();   
            this.service = new InstrutorService();
            await this.buscarEscolaridades();
            await this.buscarTipoPagamento();
            await this.buscarTipo();
            this.buscaInstrutor();
        }
 
        public async buscarEscolaridades(){   
            await this.service.getEscolaridades(  ).then(response =>{ 
               this.campos.push(
                    {
                        nome: "escolaridade",
                        type: "select",
                        label: "Escolaridade",
                        sm: 6,
                        lg: 6, 
                        disabled: false,
                        options: response.map((item) => { return { value: item.id, label: item.nome } })
                    },
                );
            });
        }
    
        public async buscarTipoPagamento(){
            await this.service.getTipoPagamento(  ).then(response =>{
               this.campos.push(
                    {
                        nome: "tipoPagamento",
                        type: "select",
                        label: "Tipo de Pagamento",
                        sm: 6,
                        lg: 6,
                        disabled: false,
                        options: response.map((item) => { return { value: item.id, label: item.nome } })
                    },
                );
            });
        }

        public async buscarTipo(){
            await this.service.getTipo(  ).then(response =>{
               this.campos.push(
                    {
                        nome: "tipo",
                        type: "select",
                        label: "Tipo de Instrutor",
                        sm: 6,
                        lg: 6,
                        disabled: false,
                        options: response.map((item) => { return { value: item.id, label: item.nome } })
                    },
                );
            });
        }
   
        get hasPermissao(   ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ] ,  this.perfis); 
        }
 
        public buscaInstrutor(){   
            this.processando = true ; 
            this.service.getModel( this.$route.params.id  ) 
            .then(response => {   
                this.modelo =  JSON.parse(JSON.stringify( response ));   
                this.processando = false ;    
            })
            .catch(error => { 
                this.processando = false ; 
            }); 
        } 
 
        public modeloAlterado(){   
            this.formulario = {}
            if(this.modelo){  
                this.service.getModel(this.modelo.id) 
                .then(response => {   
                    this.formulario =  JSON.parse(JSON.stringify( response ));  
                    this.formulario.escolaridade = this.formulario.escolaridade.id;
                    this.formulario.tipoPagamento = this.formulario.tipoPagamento.id;
                    this.formulario.status = this.formulario.status.id;
                    this.formulario.tipo = this.formulario.tipo ? this.formulario.tipo.id : 1;
                })
                .catch(error => {
                    this.formulario = { };  
                });  
            } 
        }
 
        public sucesso(){  
            this.$router.push({ name: "sigap_Instrutor"  })
        }
        
    } 
</script>